import React, { useEffect, useState } from 'react';
import { Layout } from 'antd';
import { useTranslation } from 'react-i18next';
import SEOHeader from '../components/SEOHeader';
import BackgroundImage from '../components/BackgroundImage';
import { useLocation } from 'react-router-dom';
import { LOCALE_ES } from '../i18n';
import './Constitution.css';
import PdfViewer from '../components/PdfViewer';
export const BASE_URL = process.env.REACT_APP_MEDIA_URL;

const Constitution = () => {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language ? i18n.language : LOCALE_ES;

  useEffect(() => {
    window.scrollTo({behavior: 'smooth', top: 220});
  }, [pathname]);

  return (
    <div>
      <SEOHeader titleKey='constitution' descriptionKey='constitution' />
      <Layout className="constitution-layout">
        <BackgroundImage title='church_constitution' bgImgClass="constitution-bg-image" />
        <div className='pdfviewer-container'>
          <PdfViewer pdfUrl="/codigo.pdf" />
        </div>
      </Layout>
    </div>
  );
};

export default Constitution;
